export const SETTING_TYPE = {
  SYSTEM: 'system',
  SECURITY: 'security',
  PERFORMANCE: 'performance',
  MARKETING: 'marketing',
};

export const COOKIE_AGREEMENT = 'cookie-agreement';
